<template>

    <div id="content" role="main">

        <div class="row mt-5">
          <div class="col-md-12">
            <div class="content_title">
              <h1>BIOTECH REST API</h1>
            </div>
          </div>
        </div>

      <ApiDokumentation />

    </div>

</template>

<script>

  import ApiDokumentation from '@/components/doc/ApiDokumentation.vue'

  export default {
    name: 'ApiDoc',
    components: { ApiDokumentation },
  }

</script>
